import md5 from 'tiny-hashes/md5';
import _ from './Utils.js'

class UploadController {
    constructor(storage) {
        this.storage = storage;
    }

    validateFiles(files) {
       if (!files || !files.length) {
        return "Please select one or more files for upload"
       }
    }
    parseFileContent(fileContent) {
        var values = this.csvToArray(fileContent);
        // removing the header info
        var possibleHeaders = {
            "debit": {
                "isHeader": function(cols) {
                    return cols[0].trim() === 'Date';
                }, //['Date','Description','Amount','Running Bal.'],
                "skipRow": (cols, colMap) => {
                    var desc = cols[colMap["Description"]];
                    return this.stringStartsWith(desc, "Beginning balance");
                },
                "mapping": {
                    "Date": "Date",
                    "Description": "Description",
                    "Amount": "Amount",
                    "uuid": function(cols) {
                        return md5(cols.join(','));
                    }
                }
            },
            "credit": {
                "isHeader": function(cols) {
                    return cols[0].trim() === 'Posted Date';
                }, //['Posted Date','Reference Number','Payee','Address','Amount'], 
                "mapping": {
                    "Date": "Posted Date",
                    "Description": "Payee",
                    "Amount": "Amount",
                    "uuid": "Reference Number"
                }
            }
        };
        var headerRowNumber = -1, headerObj, r, row;
        for (r = 0; r < values.length; ++r) {
            row = values[r];
            for (var type in possibleHeaders) {
                if (!Object.prototype.hasOwnProperty.call(possibleHeaders, type)) {
                    continue;
                }
                var hdrObj = possibleHeaders[type];
                if (hdrObj.isHeader(row)) {
                    headerObj = hdrObj;
                    headerRowNumber = r;
                    break;
                }
            }
            if (headerRowNumber !== -1) {
                break;
            }
        }
        if (headerRowNumber === -1) {
            //FIXME alert("Couldn't find header start of the file");
            return;
        }
        var headerColNames = {};
        var headerRow = values[headerRowNumber];
        for (var i = 0; i < headerRow.length; i++) {
            headerColNames[headerRow[i]] = i;
        }
        var resultingData = [];
        

        let locale = 'US';//this.appController.getLocale();
        let referenceMap = {};
        for (r = headerRowNumber + 1; r < values.length; r++) {
            row = values[r];
            // check if we need to skip row
            if (headerObj.skipRow && headerObj.skipRow(row, headerColNames)) {
                continue;
            }
            var date = this.getValueForCol(row, headerObj.mapping["Date"], headerColNames);
            if (locale.indexOf('ru') !== -1 && date.indexOf('/') !== -1) {
                // need to parse date from MM/d/YYYY and convert it to canonical form
                let dateParts = date.split('/');
                date = dateParts[1] + '.' + dateParts[0] + '.' + dateParts[2];
            }
            var description = this.getValueForCol(row, headerObj.mapping["Description"], headerColNames);
            var amount = this.getValueForCol(row, headerObj.mapping["Amount"], headerColNames);
            var uuid = this.getValueForCol(row, headerObj.mapping["uuid"], headerColNames);
            if (!amount) {
                console.log('Skipping row since amount is not defined',row)
                continue;
            }
            // check if id is an existing id
            if (referenceMap[uuid] ) {
                // need to generate a new id
                let newUuid = md5(row.join(','))
                console.log('Row ', row, ' has the same uuid as ', JSON.stringify(referenceMap[uuid]), ' generated a new id: ', newUuid);
                uuid = newUuid;
            }
            let resultRow = {
              uuid: uuid,
              date: _.parseWithLocalTime(date),
              description: description,
              amount: amount,
              category: ''
          }
          referenceMap[uuid] = resultRow
          resultingData.push(resultRow);
        }
        console.log(resultingData)
        return this.storage.save(resultingData.map(item=>({
            table: 'pendingTransactions',
            action: 'INSERT',
            value: item
        })));
    }
    getValueForCol(cols, getter, colsMap) {
        if (typeof getter == 'string') {
            return cols[colsMap[getter]]
        } else {
            return getter(cols, colsMap);
        }
    }

    updatePendingTransaction(transaction, changed) {
        transaction = Object.assign({}, transaction, changed);
        return this.storage.save([{
            table: 'pendingTransactions',
            action: 'UPDATE',
            value: transaction
        }]);
    }


    commitPendingTransactions() {
        let pendingTransactions = this.storage.getStore().pendingTransactions.value;
        let i;
        let actions = [];
        for (i =0; i< pendingTransactions.length; i++) {
            let row = pendingTransactions[i]
            if (row.status === 'Complete' || row.status === 'Duplicate' || row.status === 'Check') {
                continue;
            }
            // 1. check if row with such uuid exists in target
            let {foundItem, index} = this.storage.findById('transactions', row.uuid);
            if (foundItem) {
                actions.push({
                    table: 'pendingTransactions',
                    action: 'UPDATE',
                    value: Object.assign({}, row, {
                        status: 'Duplicate',
                        note: 'Found row with same uuid, row num = '+index
                    })
                });
                continue;
            }
            actions.push({
                table: 'transactions',
                action: 'INSERT',
                value: Object.assign({}, row, {
                    status: 'pending',
                    note: ''
                })
            });
            actions.push({
                table: 'pendingTransactions',
                action: 'DELETE',
                value: row
            });
        }
        return this.storage.save(actions);
    }

    clearAllPendingTransactions() {
        let pendingTransactions = this.storage.getStore().pendingTransactions.value;
        let i;
        let actions = [];
        for (i =0; i< pendingTransactions.length; i++) {
            let row = pendingTransactions[i]
            actions.push({
                table: 'pendingTransactions',
                action: 'DELETE',
                value: row
            });
        }
        return this.storage.save(actions);
    }


    
    deletePendingTransactions(uuids) {
        return this.storage.save(uuids.map(item=>({
            table: 'pendingTransactions',
            action: 'DELETE',
            value: {
                uuid: item
            }
        })));
    }



    // ref: http://stackoverflow.com/a/1293163/2343
    // This will parse a delimited string into an array of
    // arrays. The default delimiter is the comma, but this
    // can be overriden in the second argument.
    csvToArray(strData, strDelimiter) {
        // Check to see if the delimiter is defined. If not,
        // then default to comma.
        strDelimiter = (strDelimiter || ",");
        // Create a regular expression to parse the CSV values.
        var objPattern = new RegExp(
            (
                // Delimiters.
                "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
                // Quoted fields.
                "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
                // Standard fields.
                "([^\"\\" + strDelimiter + "\\r\\n]*))"), "gi");
        // Create an array to hold our data. Give the array
        // a default empty first row.
        var arrData = [
            []
        ];
        // Create an array to hold our individual pattern
        // matching groups.
        var arrMatches = null;
        // Keep looping over the regular expression matches
        // until we can no longer find a match.
        while ((arrMatches = objPattern.exec(strData))) {
            // Get the delimiter that was found.
            var strMatchedDelimiter = arrMatches[1];
            // Check to see if the given delimiter has a length
            // (is not the start of string) and if it matches
            // field delimiter. If id does not, then we know
            // that this delimiter is a row delimiter.
            if (strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter) {
                // Since we have reached a new row of data,
                // add an empty row to our data array.
                arrData.push([]);
            }
            var strMatchedValue;
            // Now that we have our delimiter out of the way,
            // let's check to see which kind of value we
            // captured (quoted or unquoted).
            if (arrMatches[2]) {
                // We found a quoted value. When we capture
                // this value, unescape any double quotes.
                strMatchedValue = arrMatches[2].replace(new RegExp("\"\"", "g"), "\"");
            } else {
                // We found a non-quoted value.
                strMatchedValue = arrMatches[3];
            }
            // Now that we have our value string, let's add
            // it to the data array.
            arrData[arrData.length - 1].push(strMatchedValue);
        }
        // Return the parsed data.
        return (arrData);
    }



    
    bytesToHex(bytes) {
        var result = '';
        for (var i = 0; i < bytes.length; i++) {
            result = result + this.byteToHex(bytes[i]);
        }
        return result;
    }

    byteToHex(b) {
        const hexChar = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"];
        return hexChar[(b >> 4) & 0x0f] + hexChar[b & 0x0f];
    }

    stringStartsWith(str, prefix) {
        return str && str.slice(0, prefix.length) === prefix;
    }
}

export default UploadController;